import CustomModal from "../CustomModal";

function DeleteUserModal({
  isOpen,
  handleClose,
  userProfile,
  onConfirmDelete,
}) {
  if (!userProfile) return null;

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="delete-modal"
    >
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/delete-modal-img.png`}
          alt="Delete user icon"
        />
        <b>
          <p>Are you sure you want to delete the selected user?</p>
        </b>

        <div className="details-container container">
          <div className="detail">
            <p>Name</p>
            <b>
              <p className="D">
                {userProfile.l_name} {userProfile.f_name}
              </p>
            </b>
          </div>
          <div className="detail">
            <p>Gym Number</p>
            <b>
              <p className="D">#{userProfile.id}</p>
            </b>
          </div>
        </div>

        <div className="warning">
          <img
            src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
            alt="Information icon"
          />
          <p>
            Note that deleting this user will remove all their data permanently.
          </p>
        </div>

        <div className="inner-member-btn">
          <button onClick={handleClose}>Cancel</button>
          <button
            style={{ backgroundColor: "red", color: "#FAFAFA" }}
            onClick={onConfirmDelete}
          >
            Delete Profile
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default DeleteUserModal;
